/*

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import butter from '../components/butter-client'


class Blog extends Component {
  state = {
    meta: {},
    data: []
  }
  async componentDidMount () {
    const { match } = this.props
    let page = match.params.page || 1

    const resp = await butter.post.list({ page: page, page_size: 10 })
    this.setState(resp.data)
  }
  render () {
    const { next_page, previous_page } = this.state.meta

    return (
      <div>
        {this.state.data.map((post, key) => {
          return (
            <div key={key}>
              <Link to={`/blog/posts/${post.slug}`}>{post.title}</Link>
            </div>
          )
        })}

        <br />

        <div>
          {previous_page && (
            <Link to={`/blog/${previous_page}`}>
              <a>Prev</a>
            </Link>
          )}

          {next_page && (
            <Link to={`/blog/${next_page}`}>
              <a>Next</a>
            </Link>
          )}
        </div>
      </div>
    )
  }
}

export default Blog
*/

import React from "react";
// import butter from '../components/butter-client'

// import Butter from 'buttercms'
var butter = require('buttercms')("90c4fecf717c1ba7e49d14aadaf7ad984138ee01");

class Blog extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			thePost: "",
			theSlug: "",
		};

	}

	componentDidMount() {
		this.fetchPage();
	}

	fetchPage() {
		// "https://api.buttercms.com/v2/pages/*/5-year-plan-to-know-you/?auth_token=90c4fecf717c1ba7e49d14aadaf7ad984138ee01"
		const that = this;
		butter.page.retrieve('*', 
			'5-year-plan-to-know-you', 
			{
			}
		).then(function(resp) {
			console.log(resp.data)
			that.setState({ thePost: resp.data.data.fields.get_to_know_someone, theSlug: resp.data.data.slug });
		}).catch(function(resp) {
			console.log(resp)
		});
	}


	render() {
		return (
		  <>
			<div className="content">

			<h2 className="title"> {this.state.theSlug} </h2>

				<div dangerouslySetInnerHTML={{ __html: this.state.thePost }} />

			</div>
		  </>
		);
	}
}

export default Blog;

